import Vue from 'vue'
import configs from '@/config'

const { ahaaiv2Url } = configs

export const SLIDE_AI_TIMEOUT_MS = 45000

let resource = null

export const actions = {
  runTask: {
    method: 'POST',
    url: `${ahaaiv2Url}/api/ai-v2/slide-ai/{task}`,
    timeout: SLIDE_AI_TIMEOUT_MS,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const runTask = async ({ task, input, language }) => {
  const body = { input: input ?? {} }
  if (language) body.language = language
  const res = await resource.runTask({ task: encodeURIComponent(task) }, body)
  return res.body
}

export default {
  initResource,
  runTask,
}
